<template>
  <b-container fluid>
    <div class="iq-card mt-3">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title">
          <h4 class="card-title">Group List</h4>
        </div>
        <b-row>
          <b-col md="12">
            <div class="text-right">
              <button-options
                :access="'master_group_company'"
                :hideDetail="true"
                :hideAdd="false"
                :isRefreshEnabled="true"
                :isRefreshed="isRefreshed"
                @onAddItemClicked="openAddForm"
                @onRefreshed="getData('Refreshed')"/>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="iq-card-body">
        <b-row>
          <b-col md="12">
            <group-list
              :access="'master_group_company'"
              :data="data"
              :loading="isLoading"
              :pagination="pagination"
              @onActionDelete="openDelete"
              @onActionEdit="openEdit"
              @onActionView="openDetail"
              @onPageChanged="onPageChanged"
              @update="onUpdated"/>
          </b-col>
        </b-row>
      </div>
      <b-modal
        size="lg"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        v-model="displayForm">
        <group-form
          :data="currentGroup"
          :errors="errors"
          :isSubmit="isSubmit"
          @onSubmitClicked="onSubmitClicked"
          @onCancelAddClicked="onCancel" />
      </b-modal>
      <b-modal
        size="lg"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        v-model="displayDeletion">
        <DeleteItem
          :isSubmit="isSubmit"
          @onCancelDeletion="displayDeletion = false"
          @onConfirmDeletion="onConfirmDeletion"/>
      </b-modal>
    </div>
  </b-container>
</template>

<script>
import DeleteItem from '@/components/directives/delete-item';
import ButtonOptions from '@/components/directives/button-options';
import GroupForm from '@/components/group/Form';
import GroupList from '@/components/group/List';
import GroupSvc from '@/services/GroupSvc';

import requestBuilder from '@/util/master/request.builder';
import { isCancelled, isAuthError, requestErrorMessage } from '@/util/master/requestError';

export default {
  name: 'Group',
  components: {
    ButtonOptions, GroupList, GroupForm, DeleteItem,
  },
  computed: {
    groups() {
      return this.$store.getters['auth/availableGroup'];
    },
  },
  data() {
    return {
      currentGroup: {},
      data: [],
      displayForm: false,
      displayDeletion: false,
      errors: {},
      filter: {},
      isLoading: false,
      isRefreshed: false,
      isSubmit: false,
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 0,
      },
    };
  },
  methods: {
    async deleteData(notification, data) {
      this.isSubmit = true;
      try {
        const resp = await GroupSvc.delete(data.grcpId);
        if (resp.data.status.error === 0) {
          await this.$toast.success(notification);
          this.displayDeletion = await false;
          this.pagination.current = 1;
          this.getData();
        } else {
          this.$toast.error(resp.data.status.message);
        }
      } catch (e) {
        this.$toast.error(e.message);
      } finally {
        this.isSubmit = false;
      }
    },
    async getData(notification) {
      this.isLoading = true;
      this.isRefreshed = true;
      try {
        const resp = await GroupSvc.getGroups({
          params: {
            ...requestBuilder.buildFilters(this.pagination, this.filter),
          },
        });
        this.data = resp.data.data || [];
        this.pagination.totalSize = resp.data.pagination?.totalData || 0;
        if (notification) {
          this.$toast.success(notification);
        }
      } catch (e) {
        if (isCancelled(e)) return;
        if (isAuthError(e)) this.doLogOut();
        else this.$toast.error(requestErrorMessage(e));
      } finally {
        this.isLoading = false;
        this.isRefreshed = false;
      }
    },
    onCancel() {
      this.currentGroup = {};
      this.displayForm = false;
    },
    onConfirmDeletion() {
      this.deleteData('Deleted complete', this.selected);
    },
    onPageChanged(page) {
      this.pagination.current = page;
      this.getData();
    },
    async onSubmitClicked(form) {
      const data = {
        grcpAddress: form.grcpAddress,
        grcpCity: form.grcpCity,
        grcpFax: form.grcpFax,
        grcpName: form.grcpName,
        grcpNickName: form.grcpNickName,
        grcpTelp: form.grcpTelp,
      };
      this.errors = {};
      this.isSubmit = true;
      try {
        let resp = {};
        if (form.grcpId) {
          resp = await GroupSvc.update(form.grcpId, data);
        } else {
          resp = await GroupSvc.create(form);
        }
        if (resp.data.status.error === 0) {
          await this.getData('Success');
          this.currentGroup = {};
          this.displayForm = false;
        } else {
          const errors = resp.data.status.message;
          if (typeof errors === 'object') {
            this.errors = resp.data.status.message;
            this.$toast.error('Error found');
          } else {
            this.$toast.error(resp.data.status.message);
          }
        }
        this.isSubmit = false;
      } catch (e) {
        if (!isCancelled(e)) this.$toast.error(requestErrorMessage(e));
        this.isSubmit = false;
      }
    },
    onUpdated() {
      this.getData('Updated');
    },
    openAddForm() {
      this.currentGroup = {};
      this.displayForm = true;
    },
    openDelete(data) {
      this.displayDeletion = true;
      this.selected = data;
    },
    openDetail(data) {
      this.$router.push({ name: 'GroupDetail', params: { id: data.grcpId } });
    },
    openEdit(data) {
      this.displayForm = true;
      this.currentGroup = { ...this._.find(this.data, (v) => v.grcpId === data.grcpId) };
    },
    doLogOut() {
      this.$toast.error('Please re-login');
      this.$store.dispatch('auth/logout');
      this.$router.replace({ name: 'Login' });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>

</style>
